import { render, staticRenderFns } from "./repairedOrder.vue?vue&type=template&id=84a63234&scoped=true&"
import script from "./repairedOrder.vue?vue&type=script&lang=js&"
export * from "./repairedOrder.vue?vue&type=script&lang=js&"
import style0 from "./repairedOrder.vue?vue&type=style&index=0&id=84a63234&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a63234",
  null
  
)

export default component.exports